import { resolveTheme, NEUTRAL } from '../../designTokens';

// T-13: radstil – avatar/ikon, titel + meta, valfritt `right`. Rader skiljs med en
// tunn linje i stället för egna kort; sista raden får `last` för att slippa linjen.
export default function ListItem({ theme, avatar, title, meta, right, onClick, style, last }) {
  const t = theme || resolveTheme();
  const base = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '11px 0',
    borderBottom: last ? 'none' : `1px solid ${t.card_border}`,
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  };
  return (
    <div onClick={onClick} style={base}>
      {avatar && <div style={{ flexShrink: 0 }}>{avatar}</div>}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: '600', color: NEUTRAL.ink, fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</div>
        {meta && <div style={{ color: NEUTRAL.muted, fontSize: '12px', marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{meta}</div>}
      </div>
      {right && <div style={{ flexShrink: 0 }}>{right}</div>}
      {onClick && !right && <span aria-hidden="true" style={{ fontSize: '14px', color: NEUTRAL.line }}>›</span>}
    </div>
  );
}
